import { Card } from "src/components/card";
import { Column, TextWithTooltip } from "@hightouch/htui";
import { MetricRows } from "src/pages/ad-studio/insights/performance/view/metric-rows";
import type { ParentCardState } from "src/pages/ad-studio/insights/performance/view/types";

type ParentCardProps = ParentCardState;

export const ParentCard = ({ name, metrics }: ParentCardProps) => (
  <Card
    flex={1}
    p={0}
    overflow="hidden"
    cursor="inherit"
    _groupHover={{ borderColor: "base.borderHover" }}
  >
    <Column p={2} gap={2} minWidth={0}>
      <TextWithTooltip fontWeight="medium">{name}</TextWithTooltip>
      <MetricRows metrics={metrics} />
    </Column>
  </Card>
);
